import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const LogoutButton = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const handle = async () => {
    await logout();
    navigate('/admin/login', { replace: true });
  };
  return (
    <button
      onClick={handle}
      data-testid="admin-logout-button"
      title="Sair"
      className="flex items-center gap-1.5 font-body text-[11px] sm:text-xs text-white/40 hover:text-[#F5EDDD] transition-colors uppercase tracking-wider"
    >
      <LogOut className="w-4 h-4" />
      <span className="hidden sm:inline">Sair</span>
    </button>
  );
};
